import { createListReducer } from 'app/redux/reducers/_reducer-factory/createListReducer';

const TEMPLATE_NAME = 'PATIENT_LIST';

export default createListReducer(TEMPLATE_NAME);
